const deliveryConfirmationIT = {
    "view": {
        "table": {
            "title": "Elenco Consegnati",
            "columns": {
                "release": "Rilascio",
                "upc": "Numero UPC",
                "action": "Azione",
                "status": "Stato",
                "deliveryDate": "Data di Consegna",
                "details": "Dettagli"
            },
            "label": {
                "statusDelivered": "CONSEGNATO",
                "statusPartially": "PARZIALMENTE",
                "statusUndelivered": "NON CONSEGNATO",
                "ddexActionInsert": "INSERISCI",
                "ddexActionFullUpdate": "AGGIORNAMENTO COMPLETO",
                "ddexActionMetadataUpdate": "AGGIORNAMENTO META.",
                "ddexActionTakedown": "RIMOZIONE"
            },
            "placeholder": {
                "search": "Cerca..."
            },
            "button": {
                "open": "APRI",
                "exportCSV": "Esporta CSV"
            }
        }
    },
    "breakdownView": {
        "table": {
            "title": "Elenco Consegne Negozio",
            "column": {
                "store": "Negozio",
                "additionalNote": "Note Aggiuntive",
                "status": "Stato"
            },
            "label": {
                "statusDelivered": "CONSEGNATO",
                "statusUndelivered": "NON CONSEGNATO"
            },
            "button": {
                "exportCSV": "Esporta CSV"
            },
            "message": {
                "appleSubjectToQC": "Consegnato con successo, soggetto a ulteriore controllo QC da parte del personale di Apple Music.",
                "releaseDeliverySuccessfull": "Il rilascio è stato consegnato con successo ai server di {{dspName}}",
                "releaseDeliveryUnsuccessfull": "La consegna del rilascio non è riuscita per {dspName}.",
                "noDeliveriesPossible": "Nessuna consegna possibile al momento"
            }
        }
    }
};

export default deliveryConfirmationIT;